import { ABO_LABEL } from 'shared/consts'
import { type ShippingOptionType } from 'shared/experiments/components/NewSerp/types'
import { SHIPPING_OPTIONS_FILTER_NAME } from 'views/components/organisms/AlgoliaInstantSearch/ProductFilter/consts'

export const SHIPPING_OPTIONS_TOGGLE_EVENT = `${SHIPPING_OPTIONS_FILTER_NAME}_TOGGLE`
export const SHIPPING_OPTIONS_RESET_EVENT = `${SHIPPING_OPTIONS_FILTER_NAME}_RESET`

export const SHIPPING_OPTIONS: ShippingOptionType[] = [
  {
    id: 'now-refinement-control',
    attribute: 'nowProductGroup',
    label: /*i18n*/ 'general.label.filterNow',
    customRefinementGroupName: SHIPPING_OPTIONS_FILTER_NAME,
    nowLabel: true,
    value: 'sameday_nextday',
  },
  {
    id: 'abo-refinement-control',
    attribute: 'filterAttributes',
    label: /*i18n*/ 'product.label.availableForAbo',
    customRefinementGroupName: SHIPPING_OPTIONS_FILTER_NAME,
    aboLabel: true,
    value: ABO_LABEL,
  },
]
